import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import * as $ from 'jquery';
import {
	FormGroup,
	FormBuilder,
	FormControl,
	Validators,
} from '@angular/forms';
//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
//models
import { quickPayModel } from '../../models/quickpay/quickpay.model';
import { AppSettings } from '../../config/settings/app-settings';
import { BaseProxyService } from '../../proxy/base-proxy.service';
import { AppComponent } from '../../app.component';
import * as jsPDF from 'jspdf';
import { Constants } from 'app/config/settings/constants';
import { amountValidator, rechargeAmountValidator } from 'app/services/custom-validation/custom-validation.service';
import CryptoJS from 'crypto-js';
import { DomSanitizer } from '@angular/platform-browser'
@Component({
	selector: 'app-signup',
	templateUrl: './quickPay.component.html',
	styleUrls: ['./quickPay.component.css']
})
export class quickPayComponent implements OnDestroy {

	//variable deceleration
	public firstName: number;
	public secondNumber: number;
	public operator: string;
	public answer: number;

	public isHt: boolean = false;
	public sysDate: any = Date.now();
	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public quickPayModel: quickPayModel = new quickPayModel;
	public allUserData: any = [];
	public registeredUserData: any = null;
	public serviceOn: boolean = false;
	public UserBillData: any = "";
	public isHideConsumerDetails: boolean = true;
	public isHideCancel: boolean = false;
	public oxigenPaymentselect: boolean = false;
	public payableData: any = "";
	public payData: any = "";
	public markDate: any = "";
	public checkSumData: any = "";
	public monthArr: any = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
	public viewpopupopen: boolean = false;
	public otpSend: boolean = false;
	public sendOtpResponeData: any = "";
	public validateOtpResponeData: any = "";
	public captchaView: string = "";
	public barCodeValue: string = "";
	public consumerIdValue: string = "";
	public billAmount: number;
	public consumerNO: number;
	public isHideQuickPay: boolean = true;
	public isHidePrepaid: boolean = true;
	public isHidePostpaid: boolean = false;
	public PAYTM_URL: string = 'https://paytm.com/electricity-bill-payment/west-bengal/india-power-corporation-ltd-asansol/prepaid-meter-recharge';
	public disableButton: boolean = true;
	public isDisableCB: boolean = true;
	public isChecked: boolean = false;
	public isPayClicked: boolean = true;
	public isShowTermsCondnts: boolean = false;
	public isTermsCond: boolean = true;
	public isHideQuickPayAmount: boolean = false;
	public consumerName: String = "";
	public payableAmount: number;
	public checkMeterSection: boolean = true;
	public prepaidSection: boolean = false;
	// public checkMeterSection: boolean = false;
	// public prepaidSection: boolean = true;
	public viewPrepaidpopupopen: boolean = false;
	public rechargeAmount: any;
	public prepaidConsumer: any;
	public transactionStatus: any;
	public registerWithoutLoginData = [
		{ consumerNo: null }
	]
	prepaidRechargeAmount: any = 200;
	transSuccess: boolean = false;
	pdfGenerateBlocked: boolean = false;
	rechargePrepaidBlocked: boolean = false;
	msgToShowWhileDownloadFile: string = Constants.msgToShowWhileDownloadFile;
	instance: any;
	limit_for_billdesk_payments: number = Constants.limit_for_billdesk_payments;
	quickPayMeter: FormGroup;
	prepaidMeterForm: FormGroup;
	public isClickedTerms: boolean = true;
	public isCaptchaMatched: boolean = true;
	public intervalId: any;
	validation_messages = {
		meterNo: [
			{
				type: 'required',
				message: 'Please Enter Meter Number.',
			},
			{
				type: 'minLength',
				message: 'Please Enter Minimum 8 Digit Number.',
			},
			{
				type: 'maxLength',
				message: 'Please Enter Maximum 8 Digit Number.',
			},
			{
				type: 'pattern',
				message: 'Please Enter valid Number.',
			}
		]
	};

	prepaidValidation_messages = {
		consumerNumber: [
			{
				type: 'required',
				message: 'Consumer id is mandatory',
			},
			{
				type: 'pattern',
				message: 'Consumer id is not valid.',
			}
		],
		phoneNo: [
			{
				type: 'required',
				message: 'Phone number is mandatory',
			}
		],
		amount: [
			{
				type: 'required',
				message: 'Please enter amount'
			},
			{
				type: 'min',
				message: 'Minimum amount should be 200.'
			},
			{
				type: 'max',
				message: 'Maximum amount should be 20000.'
			},
			{
				type: 'amountValidator',
				message: '**************Error'
			}
		],
		captcha: [
			{
				type: 'required',
				message: 'Please enter the above captcha',
			}
		]
	};

	constructor(
		public _baseProxy: BaseProxyService,
		public http: HttpTestService,
		public formBuilder: FormBuilder,
		public session: sessionServices,
		private sanitizer: DomSanitizer,
		private appComponent: AppComponent) {
		this.quickPayMeter = this.formBuilder.group(
			{
				meterNo: new FormControl('', Validators.compose([
					Validators.required,
					Validators.minLength(8),
					Validators.maxLength(13),
					Validators.pattern("^[A-Z0-9 ]+$")]))
			});
		this.initiatePrepaidForm();
	}

	initiatePrepaidForm() {
		this.prepaidMeterForm = this.formBuilder.group(
			{
				// consumerNumber: new FormControl('', Validators.compose([
				// 	Validators.required,
				// 	// Validators.minLength(7),
				// 	// Validators.maxLength(10),
				// 	Validators.pattern("^[a-zA-Z0-9 ]+$")])),

				consumerNumber: new FormControl('', Validators.compose([
					Validators.required,
					// Validators.minLength(7),
					// Validators.maxLength(10),
					Validators.pattern("^[0-9 ]+$")])),
				phoneNo: new FormControl('', Validators.compose([
					Validators.required,
					Validators.maxLength(10)])),

				amount: new FormControl('200', Validators.compose([
					Validators.required,
					Validators.min(200), 
					Validators.max(20000),
					rechargeAmountValidator,
				])),

				// amount: new FormControl('', Validators.compose([
				// 	Validators.required, Validators.min(1), Validators.max(20000)])),

				captcha: new FormControl('', Validators.compose([
					Validators.required]))
			}
		);
	}

	ngOnInit() {
		this.getSession();
		this.generateCaptcha();
		//this.getConsumerDetails();
		/* With login in this condition */
		if (this.sessionData.sessionStarted == 'true') {
			//this.getConsumerDetails();	
		}
	}

	changeValue(val) {
	}

	checkMeter() {
		this.checkMeterSection = false;
		this.prepaidSection = true;
		this.generateCaptcha();
		// this.http.validateCheckMeter(param).subscribe((result:any) => {
		// 	if(result.responseStatus == 1){
		// 	  this.successMsg = result.responseMessage;

		// 	}else{
		// 	  this.errorMsg = result.responseMessage;
		// 	}
		//   }, (error:any) => {
		// 	this.errorMsg = error;
		//   },() => {
		// 	this.serviceOn = false
		// });
	}

	makePayment() {
		// console.log(this.prepaidMeterForm.value)

		// this.http.prepaidPayment(param).subscribe((result:any) => {
		// 	if(result.responseStatus == 1){
		// 	  this.successMsg = result.responseMessage;

		// 	}else{
		// 	  this.errorMsg = result.responseMessage;
		// 	}
		//   }, (error:any) => {
		// 	this.errorMsg = error;
		//   },() => {
		// 	this.serviceOn = false
		// });
	}

	cancelTransSuccess() {
		this.transSuccess = false;
	}


	//get session details
	getSession = function () {
		this.sessionData = this.session.getSessionDetails();
	}

	rechargePrepaid() {
		// if (this.sessionData.sessionStarted == 'true') {
		// 	this.getConsumerDetails();
		// }

		this.isHideQuickPay = true;
		this.isHidePrepaid = false;
		// this.isHidePrepaid = true;
		this.isHidePostpaid = true;

		this.checkMeterSection = false;
		this.prepaidSection = true;

		this.intervalId = setInterval(() => {
			this.generateCaptcha();
		}, 30000); // 30 seconds

	}

	ngOnDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}


	payWithPaytm() {
		let newWindow = window.open(this.PAYTM_URL, "_blank");
		if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
			this.rechargePrepaidBlocked = true;
			setTimeout(() => { this.rechargePrepaidBlocked = false; }, 3000);
		}
	}
	rechargePostpaid() {
		// if (this.sessionData.sessionStarted == 'true') {
		// 	this.getConsumerDetails();
		// }

		this.isHideQuickPay = false;
		this.isHidePrepaid = true;
		this.isHidePostpaid = true;
	}

	//get consumer details
	getConsumerDetails = function () {
		var self = this;
		// self.serviceOn = true;
		self.isHideConsumerDetails = true;
		//self.isHideConsumerDetails = false;
		self.errorMsg = "";

		var requestedConsumer = (self.sessionData.sessionStarted == "true") ? self.sessionData.sessionId : self.quickPayModel.consumerId;

		self.http.getUserDetailsByConsNo(requestedConsumer)
			.subscribe(
				(data) => {
					self.allUserData = data;

					if (self.allUserData.status === "GAYACONSUMERID") {
						self.errorMsg = "Service is not available for this number range";
						self.allUserData = "";
						// self.serviceOn = false;
					} else {
						this.getpayAmount();
					}

				},
				(error) => {
					self.errorMsg = error;
					self.allUserData = "";
					// self.serviceOn = false;
				},
				() => {

					if (self.allUserData != "") {
						if (self.allUserData.name) {
							this.appComponent.getBroadCastForMyConsumption(self.allUserData.region, self.allUserData.businessAreaText)//"Asansol-DPS", "Gopalpur"
							self.registeredUserData = self.allUserData;
							this.consumerNO = self.registeredUserData.consumerNo;
							this.consumerName = self.registeredUserData.name;

						} else {
							self.registeredUserData = "";
							self.errorMsg = "Provided Consumer No is not Valid";
							self.payData = '';
							self.isHideQuickPayAmount = true;
							//self.payData.amount='0';
						}
						// self.serviceOn = false;
					}
				}
			);
	}

	cancelPayment = function () {
		var self = this;
		if (this.payData != '') {
			this.payData.amount = 0;
			this.payData.previousMonthOutstanding = 0;
			this.payData.currentMonthBill = 0;
			this.payData.totalOutstandingBill = 0;
		}

		if (this.sessionData.sessionStarted === 'true') {
			this.isHidePrepaid = false;
			this.isHidePostpaid = false;
		}
		//this.isHideQuickPay = false;
		///self.isHideConsumerDeatils = false;
		self.isHideCancel = false;
		self.quickPayModel.consumerId = "";
		self.registeredUserData = null;
		self.UserBillData = "";
		self.payableData = "";
		self.generateCaptcha();
		self.quickPayModel.reEnterCaptcha = "";
		self.barCodeValue = "";
		self.isHt = false;
	}

	getPayableAmountProceed() {
		// this.quickPayModel.paymentOpt = "BILLDESK";
		this.quickPayModel.paymentOpt = "";
		this.isDisableCB = true;
		this.isChecked = false;
		this.getPayableAmount();
		this.viewpopupopen = true;
	}

	getPrepaidPayableAmountProceed() {
		this.serviceOn = true;
		this.errorMsg = '';
		let param = {
			"consumerNo": this.prepaidMeterForm.value.consumerNumber,
			"phoneNo": this.prepaidMeterForm.value.phoneNo,
			"amount": this.prepaidMeterForm.value.amount
		}

		this.http.getPrepaidMeterDetail(param).subscribe((result: any) => {

			if (result.status == 1) {
				this.prepaidConsumer = result.response[0]
				this.quickPayModel.paymentOpt = "1";
				//this.quickPayModel.paymentOpt = "";
				this.isDisableCB = false;
				this.isChecked = false;
				// this.getConsumerDetails();
				this.viewPrepaidpopupopen = true;
				this.serviceOn = false;

				this.generateCaptcha();
				this.prepaidMeterForm.reset(this.prepaidMeterForm.value);
			}
			else {
				this.errorMsg = result.message;
			}
		}, (error: any) => {
			this.errorMsg = error;
			this.serviceOn = false;
		}, () => {
			this.serviceOn = false
		});
	}


	closePrepaidPayOpt = function () {
		// alert("OKKK");
		var self = this;
		if (self.sessionData.sessionStarted == "true") {
			this.isHidePrepaid = false;
			this.isHidePostpaid = false;
		} else if (self.sessionData.sessionStarted == "false") {
			this.getConsumerDetails();
		}
		self.isHideConsumerDetails = true;
		self.viewPrepaidpopupopen = false;
		self.isHideCancel = true;
		self.quickPayModel.paymentOpt = "";
		self.isHideQuickPay = false;
		self.isHideConsumerDetails = false;
	}

	startPrepaidPayment() {
		this.serviceOn = true;
		this.isClickedTerms = true;

		this.isChecked = false;
		// this.isPayClicked = false;
		let param = {
			"consumerId": this.prepaidConsumer.consumerNo,
			"connectionNo": this.prepaidConsumer.connNo,
			"phoneNo": this.prepaidConsumer.phoneNo,
			"amount": this.prepaidConsumer.amount,
			"paymentThroughChannelNo": "1",
			"paymentThoughGatewayNo": this.quickPayModel.paymentOpt,
		}

		this.http.prepaidPaymentInitiate(param).subscribe((result: any) => {

			if (result.status == 1) {
				if (result.paymentThoughGatewayNo == 1 && result.redirectUrl) {
					// window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
					window.location.href = result.redirectUrl;
					this.serviceOn = false;
				}
				else {
					if (result.orderNo && result.orderNo.length > 0) {
						let options: any = {
							"key": Constants.rzp_key,
							"amount": (this.prepaidConsumer.amount * 100), /* amount to be passed as lowest currency unit */
							"name": "INDIA POWER",
							"description": "Payment",
							"image": "./assets/images/logo.jpg",
							"order_id": result.orderNo,
							"meter_no": result.meterNo,
							"modal": {
								"escape": false
							},
							"prefill": {
								// "name": this.postPaymentData.consumerId,
								// "email": "gaurav.kumar@example.com",
								// "contact": "9999999999",
								// "method": 'card',
								// 'card[number]': finalObj.cardDetail.cardNumber,
								// 'card[expiry]': finalObj.cardDetail.cardExpDate,
								// 'card[cvv]': finalObj.cardDetail.cardCvv
							},
							"notes": {
								"Consumer_Id": this.postPaymentData.consumerId
							},
							// "theme": {
							// 	"color": "#0d4371"
							// }
						};
						options.handler = ((response) => {
							options['payment_response_id'] = response.razorpay_payment_id;
							this.handleRazorpayPrepaidResponse(response);
							this.serviceOn = false;
						});
						options.modal.ondismiss = (() => {
							this.serviceOn = false;
							this.isClickedTerms = false;
						});
						let rzp = new this.http.nativeWindow.Razorpay(options);
						rzp.open();

					} else {
						this.errorMsg = 'Order could not be created, please try again later.';
					}
				}
			}
			else {
				this.errorMsg = result.message;
			}
		}, (error: any) => {
			// this.errorMsg = error;
		}, () => {
			// this.serviceOn = false
		});
	}

	showTermsCondtn() {
		if (this.isChecked) {
			this.disableButton = true;
			this.isShowTermsCondnts = false;
		} else {
			this.disableButton = false;
			this.isShowTermsCondnts = true;
		}
	}

	openTermsCondition() {
		this.isClickedTerms = false;
		this.isTermsCond = false;
	}

	getpayAmount() {
		var consumerNo = '';
		var self = this;
		self.serviceOn = true;
		if (this.quickPayModel.consumerId === null || this.quickPayModel.consumerId === undefined || this.quickPayModel.consumerId.trim() === '') {
			consumerNo = this.sessionData.consumerId;
		}
		else {
			consumerNo = this.quickPayModel.consumerId;
		}

		/* added to filter specific consumer id list to be restricted; instruction from Sandip Saha on 03.02.2020 */
		if (this.sessionData.sessionStarted != 'true') {
			let numericConsumerNo: number = parseInt(consumerNo);
			if (Constants.restrictedConsumerList.indexOf(numericConsumerNo) > -1) {
				this.errorMsg = "Please login to view bill details!";
				this.allUserData = "";
				this.serviceOn = false;
				return;
			}
		}

		this.http.getPayableAmount(consumerNo)
			.subscribe(
				(data) => {
					// console.log("Paydata..", data)
					this.payData = data
					this.payableAmount = parseInt(this.payData.totalOutstandingBill);
					self.serviceOn = false;
				},

				(error) => {
					//self.errorMsg = error;
					this.payableData = "";
					self.serviceOn = false;
				},
				() => {

				}
			);
	}

	getPayableAmount = function () {
		var self = this;
		self.serviceOn = true;
		if (self.quickPayModel.consumerId != null || self.quickPayModel.consumerId != undefined) {
			self.registeredUserData = this.registerWithoutLoginData;
			self.registeredUserData.consumerNo = self.quickPayModel.consumerId;
		}

		var reqId = (self.sessionData.sessionStarted == "true") ? self.sessionData.sessionId : self.registeredUserData.consumerNo;

		if (self.sessionData.sessionStarted == "false") {
			reqId = null;
			reqId = self.registeredUserData.consumerNo;
		}

		//alert(reqId);
		//var consumerNo = self.quickPayModel.consumerId;
		//alert(consumerNo);
		self.http.getAsansolBill(reqId).subscribe(
			(data: any) => {
				// console.log("AsansolBill", data)
				self.UserBillData = data;
			},
			(error) => {
				//self.errorMsg = error;
				self.UserBillData = "";
			});

		self.http.getPayableAmount(reqId)
			.subscribe(
				(data) => {
					// console.log("Payable Amount", data)
					self.payableData = data;
					this.billAmount = self.payableData.totalOutstandingBill;
					self.serviceOn = false;
				},

				(error) => {
					self.serviceOn = false;
					self.payableData = "";
				},
				() => {
					if (self.payableData.totalOutstandingBill != "0" && self.payableData.totalOutstandingBill != '' && self.payableData.totalOutstandingBill && self.payableData.totalOutstandingBill != undefined) {
						self.getBillDetails();
						self.serviceOn = false;
					}
				}
			);
	}

	valueChange(value) {
		if ((value == "BILLDESK" && this.payableAmount < this.limit_for_billdesk_payments)
			|| value == "RAZORPAY") {
			this.isDisableCB = false;
			if (this.isChecked === true)
				this.isChecked = false;
		} else {
			this.isDisableCB = true;
			if (this.isChecked === true)
				this.isChecked = false;
		}
	}

	prepaidValueChange(value) {
		if (value == "1" || value == "2") {
			this.isDisableCB = false;
			if (this.isChecked === true)
				this.isChecked = false;
		} else {
			this.isDisableCB = true;
			if (this.isChecked === true)
				this.isChecked = false;
		}
	}

	getBillDetails = function () {

		var self = this;
		self.serviceOn = true;
		self.barCodeValue = "";
		//var reqId = self.registeredUserData.consumerNo;
		var reqId = self.sessionData.consumerId;
		//alert("QuickPay: "+reqId);\

		//if ((self.registeredUserData.tariff).startsWith("HTS")) {
		//	self.isHt = true;

		/* SERVICE FOR GAYA did not implement at that time */
		// if ((self.registeredUserData.region).startsWith("GAYA")) {
		// 	self.http.getHTGayaBill(self.payableData.lastDocno)
		// 		.subscribe(
		// 			(data) => {
		// 				self.UserBillData = data;
		// 				JSON.stringify("USER BILL DATA: " + self.UserBillData);
		// 			},
		// 			(error) => {
		// 				self.errorMsg = error;
		// 				self.UserBillData = "";
		// 			},
		// 			() => {
		// 				self.registeredUserData = '';
		// 				self.serviceOn = false;
		// 				self.barCodeValue = 'X' + ((self.UserBillData.billParam4).split("|"))[1];
		// 			}
		// 		);
		// }
		//} 
		// else {
		// 	if ((self.registeredUserData.region).startsWith("GAYA")) {
		// 		var consumerNo = self.quickPayModel.consumerId;
		// 		self.payableData.lastDocno = 	self.quickPayModel.consumerId;
		// 		self.http.getGayaBill(self.payableData.lastDocno)

		// 			.subscribe(
		// 				(data) => {
		// 					self.UserBillData = data;
		// 					JSON.stringify("Bill Data: " + self.UserBillData);
		// 				},
		// 				(error) => {
		// 					self.errorMsg = error;
		// 					self.UserBillData = "";
		// 				},
		// 				() => {
		// 					self.registeredUserData = '';
		// 					var dudt = ((self.UserBillData.billParam4).split("|"))[3];
		// 					var dd = dudt.split("-")[0];
		// 					var mm = self.monthArr.indexOf(dudt.split("-")[1]) + 1;
		// 					if (mm < 10) { mm = "0" + mm };
		// 					if (dd < 10) { dd = "0" + dd };
		// 					var yyyy = dudt.split("-")[2];
		// 					var cutoff = new Date(mm + "/" + dd + "/" + yyyy);//markDate
		// 					var previewCutoff = cutoff.setDate(cutoff.getDate() + 10);
		// 					self.markDate = new Date(previewCutoff).getDate() + "-" + self.monthArr[new Date(previewCutoff).getMonth()] + "-" + new Date(previewCutoff).getFullYear();
		// 					self.serviceOn = false;
		// 					self.barCodeValue = 'X' + ((self.UserBillData.billParam4).split("|"))[1];
		// 				}
		// 			);
		//}
		// else {

		self.http.getAsansolBill(this.consumerNO)
			.subscribe(
				(data: any) => {
					self.UserBillData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.UserBillData = "";
				},
				() => {
					self.registeredUserData = '';
					self.serviceOn = false;
				}
			);
		//}

		//	}
	}

	choosePayOpt = function () {
		var self = this;
		self.viewpopupopen = true;
		self.oxigenPaymentselect = false;

	}

	cancelTermsCondtn() {
		this.isTermsCond = true;
	}

	closePayOptPrepaid() {
		var self = this;
		// if (self.sessionData.sessionStarted == "true") {
		// 	this.isHidePrepaid = false;
		// 	this.isHidePostpaid = false;
		// } else if (self.sessionData.sessionStarted == "false") {
		// 	this.getConsumerDetails();
		// }
		this.isHidePrepaid = false;
		self.isHideConsumerDetails = true;
		self.viewPrepaidpopupopen = false;
		self.isHideCancel = true;
		self.quickPayModel.paymentOpt = "";
		this.initiatePrepaidForm();
		this.generateCaptcha();
		this.isClickedTerms = true;
	}

	closePayOpt = function () {
		// alert("OKKK");
		var self = this;
		if (self.sessionData.sessionStarted == "true") {
			this.isHidePrepaid = false;
			this.isHidePostpaid = false;
		} else if (self.sessionData.sessionStarted == "false") {
			this.getConsumerDetails();
		}
		self.isHideConsumerDetails = true;
		self.viewpopupopen = false;
		self.isHideCancel = true;
		self.quickPayModel.paymentOpt = "";
		//self.isHideQuickPay = false;
		//self.isHideConsumerDetails = false;
	}

	sendOTP = function () {
		var self = this;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		self.http.sendOxigenOtp("918621037165", "15")
			.subscribe(
				(data) => {
					self.sendOtpResponeData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.sendOtpResponeData = "";
				},
				() => {
					if (self.sendOtpResponeData) {
						self.otpSend = true;
						self.successMsg = "OTP sent to your mobile. Please enter the same for validation";
					}
				}
			);
	}

	validateOTP = function () {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = ((self.UserBillData.billParam).split("%7C"))[2];
		var requestedOtp = self.quickPayModel.consumerOtp;

		self.http.validateOTP(requestedConsumer + "^" + requestedOtp)
			.subscribe(
				(data) => {
					self.validateOtpResponeData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.validateOtpResponeData = "";
				},
				() => {
					if (self.validateOtpResponeData) {
						self.startPayment();
					} else {
						self.errorMsg = "OTP mismatched. Please enter the right OTP.";
					}
				}
			);
	}


	startPayment = function () {
		var self = this;
		if (self.quickPayModel.paymentOpt == "BILLDESK") {

			self.billDeskPayment();
		} else if (self.quickPayModel.paymentOpt == "RAZORPAY") {
			self.payWithRazorpayGateway();
		} else if (self.quickPayModel.paymentOpt == "PAYTM") {
			self.paytmPayment();
		} else if (self.quickPayModel.paymentOpt == "OXIGEN") {
			self.oxigenPayment();
		}
	}

	oxigenPayment = function () {
		var self = this;
		self.oxigenPaymentselect = true;
	}


	paytmPayment = function () {
		var self = this;
		window.location.href = AppSettings.PAYTM_URL;
	}

	public postPaymentData = {
		"applicationNumber": null,
		"paymentType": null,
		"amount": null,
		"consumerId": null,
		"gateway": null,
		"paymentChannelId": null
	}

	billDeskPayment = function () {

		// 	var self = this;

		// 	var requestedMob = (self.registeredUserData.mobile == null || self.registeredUserData.mobile == undefined || self.registeredUserData.mobile == '')?'NA':self.registeredUserData.mobile;
		// 	var timestamp = new Date().getTime();
		// 	var createdMsgStrngchcksum = AppSettings.BILLDESK_MARCH+"%7C"+((self.UserBillData.billParam).split("|"))[3]+timestamp+"%7CNA%7C"+self.payableData.amount+"%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C"+AppSettings.BILLDESK_SEC+"%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7C"+((self.UserBillData.billParam).split("|"))[3]+"%7C"+requestedMob+"%7C"+self.payableData.lastDocno+timestamp+"%7Chttp:fwdSlashfwdSlash192.168.1.55:8080fwdSlashpaymentfwdSlashpayment.jsp";
		// 	var createdMsgStrng =        AppSettings.BILLDESK_MARCH+"%7C"+((self.UserBillData.billParam).split("|"))[3]+timestamp+"%7CNA%7C"+self.payableData.amount+"%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C"+AppSettings.BILLDESK_SEC+"%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7C"+((self.UserBillData.billParam).split("|"))[3]+"%7C"+requestedMob+"%7C"+self.payableData.lastDocno+timestamp+"%7Chttp://192.168.1.55:8080/payment/payment.jsp";
		// 	self.http.getChecksum(createdMsgStrngchcksum)
		// 	  .subscribe(
		// 		(data) => {
		// 			self.checkSumData = data;
		// 			alert("Checksum Data: "+self.checkSumData)
		// 		  },
		// 		(error) => {
		// 			self.errorMsg = error;
		// 			self.checkSumData = "";
		// 		},
		// 		() => {
		// 			window.location.href = AppSettings.BILLDESK_URL+"?msg="+createdMsgStrng+"%7C"+self.checkSumData.value;
		// 		}
		// );
		var self = this;

		if (self.quickPayModel.consumerId != null && self.quickPayModel.consumerId != "") {
			self.consumerNo = self.quickPayModel.consumerId;

			//alert("consumerNo"+self.consumerNo );
		} else {
			self.consumerNo = self.sessionData.consumerId;

			//	alert("self.consumerNo"+self.consumerNo);
		}


		var timestamp = new Date().getTime();
		var paymentType = 3;
		var payChannelId = 1;
		self.postPaymentData.consumerId = self.consumerNo;
		self.postPaymentData.paymentType = paymentType;
		// self.postPaymentData.amount = this.billAmount;
		// console.log("this.billAmount ..>>>>>", this.billAmount)
		// console.log("self.postPaymentData....>>>>>>", self.postPaymentData)
		if (this.billAmount) {
			self.postPaymentData.amount = this.billAmount;
		}
		else {
			self.postPaymentData.amount = this.rechargeAmount;
		}
		//self.postPaymentData.amount = 0
		this.postPaymentData.gateway = 1;
		self.postPaymentData.paymentChannelId = payChannelId;
		if (!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			//alert('amount 0')
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

		if (this.postPaymentData.amount >= 500000) {
			this.errorMsg = 'Can not proceed with bill amount >= 500000.';
			return false;
		}

		self.http.postPayEmd(self.postPaymentData)
			.subscribe(
				(data) => {

					if (data && data.sourceSystem && data.sourceSystem.length > 20) {
						self.initiatePaymentData = data.sourceSystem;
						window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
					} else {
						self.errorMsg = "Unable to proceed payment!";
					}

				},
				(error) => {
					self.errorMsg = error;
				},
				() => {

					self.successMsg = "";
					self.serviceOn = false;
				}
			)
	}

	randomString = function (len, an) {
		an = an && an.toLowerCase();
		var str = "", i = 0, min = an == "a" ? 10 : 0, max = an == "n" ? 10 : 62;
		for (; i++ < len;) {
			var r = Math.random() * (max - min) + min << 0;
			str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
		}
		return str;
	}

	generateCaptcha = function () {

		// ********************previous implementation************************
		var self = this;
		self.captchaView = "";
		// var cap = self.randomString(6);
		// self.captchaView = cap;
		// ******************************************************************

		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let captchaText = '';
		for (let i = 0; i < 6; i++) {
			captchaText += characters.charAt(Math.floor(Math.random() * characters.length));
		}

		self.captchaView = captchaText;
		// this.captchaView = "";
		// this.firstNumber = Math.floor(Math.random() * 10) + 1;
		// this.secondNumber = Math.floor(Math.random() * 10) + 1;
		// const operators = ['+', '-', '*'];
		// this.operator = operators[Math.floor(Math.random() * operators.length)];

		// switch (this.operator) {
		// case '+':
		// 	this.answer = this.firstNumber + this.secondNumber;
		// 	break;
		// case '-':
		// 	this.answer = this.firstNumber - this.secondNumber;
		// 	break;
		// case '*':
		// 	this.answer = this.firstNumber * this.secondNumber;
		// 	break;
		// }

		// this.captchaView = `${this.firstNumber} ${this.operator} ${this.secondNumber}`;
	}

	validateCaptcha(userInput: number) {
		return userInput === this.answer;
	}

	// pdfGenerate = function(){
	// 	//alert("ok");
	// 	var self = this;
	// 	self.consumerNo = self.quickPayModel.consumerId;
	// 	//alert(self.consumerNo);
	// 	self.http.createAndDownloadPdf(self.consumerNo).subscribe(
	// 		(data) => {
	// 			alert("ok");
	// 			self.returnData = data;

	// 			if(!self.returnData){
	// 				self.errorMsg = "Error in downloding the created PDF";
	// 			}else if(self.returnData){
	// 				self.errorMsg = "";
	// 				alert("ok1");
	// 				alert(self.returnData);
	// 			}
	// 		},
	// 			(error) => {
	// 			self.errorMsg = error;
	// 		},
	// 			() => {}
	// 	);
	// }

	pdfGenerate = function () {
		var self = this;
		self.serviceOn = true;
		// alert("973 "+self.quickPayModel.consumerId);
		if (self.quickPayModel.consumerId != null && self.quickPayModel.consumerId != "") {
			self.consumerNo = self.quickPayModel.consumerId;
			// alert("976 "+"consumerNo"+self.consumerNo );
		} else {
			self.consumerNo = self.sessionData.consumerId;
			// alert("979 "+"self.consumerNo"+self.consumerNo);
		}

		self.http.createAndDownloadPdf(self.consumerNo).subscribe(
			success => {
				// alert("984 "+success);

			}, error => {
				self.errorMsgs = "Error in Invoice Pdf file creation !";
				if (error.error.text == "success") {
					self.http.downloadDocument(this.consumerNo).subscribe(
						(downloadSuccess) => {
							// console.log("downloadSuccess>>>>>>>>>", downloadSuccess)
							const blob = downloadSuccess.blob();
							if (blob == null) {
								// alert("993 "+"11111")
								self.serviceOn = false;
							} else {
								// alert("996 "+"2222")

							}

							const file = new Blob([blob], {});
							var fileURL = URL.createObjectURL(blob);

							let newWindow = window.open(fileURL);
							if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
								self.pdfGenerateBlocked = true;
								setTimeout(() => { self.pdfGenerateBlocked = false; }, 3000);
							}

							self.serviceOn = false;
						}).then(
							(resolve: any) => {
								alert("Invoice Bill downloded Successfully !")
							},
							(reject: any) => {
								// console.log("*******", reject)
								self.errorMsg = "Error in downloding the PDF";
							});


					// .then(
					// 	resolve => {
					// 			alert("1012 "+"Invoice Bill downloded Successfully !")
					// 	},
					// 	reject => {
					// 		self.errorMsg = "Error in downloding the PDF";
					// 	});
				}
			});
	}







	// self.http.downloadDocument(this.consumerNo).subscribe(
	// 	success => {
	// 		const blob = success.blob();
	// 		const file = new Blob([blob], {});
	// 		var fileURL = URL.createObjectURL(blob);
	// 		window.open(fileURL);
	// 	},
	// 	error => {
	// 		this.blockUI.stop();
	// 		this.toastMgr.errorToastr('File download some error found', 'ERROR');
	// 	});
	// if (success != null) {
	// 	self.http.downloadDocument(this.consumerNo).subscribe(
	// 		downloadSuccess => {
	// 			const blob = downloadSuccess.blob();
	// 			const file = new Blob([blob], {});
	// 			var fileURL = URL.createObjectURL(blob);
	// 			window.open(fileURL);
	// 		}).then(
	// 			resolve => {
	// 				alert("Invoice Bill downloded Successfully !")
	// 			},
	// 			reject => {
	// 				self.errorMsg = "Error in downloding the PDF";
	// 			});
	// }
	// var self = this;
	// self.serviceOn = true;
	// var reqId = (self.sessionData.sessionStarted == "true")?self.sessionData.sessionId:self.registeredUserData.consumerNo;
	// alert("reqId"+reqId);

	// var doc = new jsPDF('p', 'mm', 'a4');
	// doc.internal.scaleFactor = 5;
	// doc.addHTML($('#userBill'),30,6, {pagesplit: true, background:"#ffffff"}, function () { doc.save('Bill.pdf');})

	// Save the PDF
	//doc.save('Test.pdf');

	clearBroadCastDataForQuickPayLogin() {
		this.appComponent.getBroadCastForMyConsumption(null, null);
	}

	payWithRazorpayGateway() {
		let consumerNo: any;
		if (this.quickPayModel.consumerId != null && this.quickPayModel.consumerId != "") {
			consumerNo = this.quickPayModel.consumerId;
			//alert("consumerNo"+self.consumerNo );
		} else {
			consumerNo = this.sessionData.consumerId;
			//	alert("self.consumerNo"+self.consumerNo);
		}

		// this.billAmount = 100; // TODO: remove beore production
		var paymentType = 3;
		var payChannelId = 1;
		this.postPaymentData.consumerId = consumerNo;
		this.postPaymentData.paymentType = paymentType;
		this.postPaymentData.amount = this.billAmount;
		this.postPaymentData.gateway = 2;
		this.postPaymentData.paymentChannelId = payChannelId;

		if (!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

		// initiate payment request
		this.http.postPayEmd(this.postPaymentData).subscribe((data) => {
			if (data['orderNo'] == null) { this.errorMsg = 'Could not proceed with gateway, please try again later.'; return; }
			let orderNo: String = data['orderNo'];
			if (orderNo && orderNo.length > 0) {
				let options: any = {
					"key": Constants.rzp_key,
					"amount": (this.postPaymentData.amount * 100), /* amount to be passed as lowest currency unit */
					"name": "INDIA POWER",
					"description": "Payment",
					"image": "./assets/images/logo.jpg",
					"order_id": orderNo,
					"modal": {
						"escape": false
					},
					"prefill": {
						// "name": this.postPaymentData.consumerId,
						// "email": "gaurav.kumar@example.com",
						// "contact": "9999999999",
						// "method": 'card',
						// 'card[number]': finalObj.cardDetail.cardNumber,
						// 'card[expiry]': finalObj.cardDetail.cardExpDate,
						// 'card[cvv]': finalObj.cardDetail.cardCvv
					},
					"notes": {
						"Consumer_Id": this.postPaymentData.consumerId
					},
					// "theme": {
					// 	"color": "#0d4371"
					// }
				};
				options.handler = ((response) => {
					options['payment_response_id'] = response.razorpay_payment_id;
					this.handleRazorpayResponse(response);
				});
				options.modal.ondismiss = (() => {
					//   this.loginService.SetLoader = false;
				});
				let rzp = new this.http.nativeWindow.Razorpay(options);
				rzp.open();
			} else {
				this.errorMsg = 'Order could not be created, please try again later.';
			}

		}, (error) => {
			this.errorMsg = error;
		}, () => {
			this.successMsg = "";
			this.serviceOn = false;
		});
	}

	handleRazorpayPrepaidResponse(razorpayResponse) {
		this.http.postRazorpayPrepaidResponse(razorpayResponse).subscribe((resp) => {
			if (resp['paymentProcessingStatus'] == 1) {
				this.successMsg = resp['paymentProcessingMessage'];
				window.location.href = this.successMsg;
				// setTimeout(() => { window.location.reload(); }, 5000);

			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}

	handleRazorpayResponse(razorpayResponse) {
		this.http.postRazorpayResponse(razorpayResponse).subscribe((resp) => {
			if (resp['status'] === 'success') {
				this.successMsg = resp['paymentProcessingMessage'];
				setTimeout(() => { window.location.reload(); }, 5000);
				/* let paramText = "Payment is successful!&billPeriod=" + lastMonthInString + "&consumerId="
							+ consumerDetail.getTransactionId() + "&paymentAmount="
							+ String.valueOf(paymentMaster.getAmount()) + "0"
							+ "&dateOfTransaction="
							+ dateFormats1.format(paymentMaster.getDate())
							+ "&paymentGateway=BILLDESK_PAYMENT&paymentReference="
							+ razorpayPaymentResponse.getRazorpay_payment_id()
							+ "&status=Success&reason=Payment Successful!" */
			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}

	onSearchChange(searchValue: string): void {

		// this.isCaptchaMatched= this.validateCaptcha(parseInt(searchValue))

		// ********************previous implementation************************
		if (searchValue.length == 6) {
			if (searchValue == this.captchaView) {
				this.isCaptchaMatched = true;
			}
			else {
				this.isCaptchaMatched = false;
			}
		}
		else {
			this.isCaptchaMatched = true;
		}
		// ******************************************************************
	}
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/quickPay/quickPay.component.ts